module.exports = __webpack_public_path__ + "img/4-viimeinen-lento.57549793.jpg";